import validate from "/home/cyburstud/developer/github/cubpp/mileage.autos/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}